
import React from 'react';
import { Search, Upload, User, LogOut } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useToast } from '@/components/ui/use-toast';
import { useAuth } from '@/contexts/AuthContext';

const Header = ({ onUploadClick, onSearchChange }) => {
  const { toast } = useToast();
  const { user, logout } = useAuth();

  const handleSearchClick = () => {
    toast({
      title: "Busca Ativada! 🚧",
      description: "A funcionalidade de busca está sendo conectada. Por enquanto, a filtragem funciona pelo sidebar!",
      variant: "default",
    });
  };

  return (
    <div className="flex justify-between items-center h-full px-6">
      <div className="flex-1 max-w-2xl">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 h-4 w-4" />
          <input
            type="text"
            placeholder="Pesquisar..."
            className="w-full pl-10 pr-4 py-2 bg-slate-800/50 border border-slate-700/50 rounded-full text-sm focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-slate-200 placeholder-slate-500 hover:bg-slate-800/80"
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>
      
      <div className="flex items-center gap-4 ml-4">
          <button 
            className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-500 hover:to-cyan-400 text-white px-5 py-2 rounded-full font-medium shadow-lg shadow-blue-500/20 transition-all duration-300 transform hover:scale-105 active:scale-95 flex items-center gap-2"
            onClick={onUploadClick}
          >
            <Upload className="h-4 w-4" />
            <span className="text-sm">Upload</span>
          </button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="relative h-10 w-10 rounded-full">
                <Avatar className="h-10 w-10 border-2 border-cyan-400/50">
                  {user?.photoURL ? <AvatarImage src={user.photoURL} alt={user?.email} /> : null}
                  <AvatarFallback>
                    <User className="text-cyan-300"/>
                  </AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56 glass-effect" align="end" forceMount>
              <DropdownMenuLabel className="font-normal">
                <div className="flex flex-col space-y-1">
                  <p className="text-sm font-medium leading-none text-white">Olá, {user?.displayName || user?.name || 'Usuário'}!</p>
                  <p className="text-xs leading-none text-blue-300/80">{user?.email}</p>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout} className="cursor-pointer">
                <LogOut className="mr-2 h-4 w-4" />
                <span>Sair</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
    </div>
  );
};

export default Header;
  